import { Row, Col, Card } from 'antd';
import {common} from '@bit/ui-common.ui-components/ss-common-data/staticConfig.json';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { IconPopover } = ssCommonUtils;

export default class StepperHeader extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { text } = this.props;

        let dodEmail, dodPhone;
        if(text['CINFO']) {
            dodEmail = (
                <span style={{ fontWeight: 'bold' }}>
                    {text['CINFO'].c[0].text}
                </span>
            );
            dodPhone = (
                <span style={{ fontWeight: 'bold' }}>
                    {text['CINFO'].c[1].text}
                </span>
            );
        }

        return (
            <div>
                <Row type='flex' justify='space-around' align='middle' style={{ margin: '15px 0 15px 0' }}>
                    <Col span={23} style={{ fontWeight: 'bold', fontSize: '24px' }}>
                        <Card bodyStyle={{ padding: '10px', textAlign: 'center' }}>
                            {'FTSP '}
                            <span style={{ color: 'rgb(53, 158, 255)' }}>
                                {'Candidate'}
                            </span>
                            {' Registration'}
                        </Card>
                    </Col>
                </Row>
                        {dodEmail == null || dodPhone == null ? null : (
                            <div style={{ textAlign:'center', paddingTop:'5px', fontWeight:'bold' }}>
                              <a style={{ color: 'rgb(53, 158, 255)', paddingLeft:'80px' }} href={common.guide} target="_blank">
                                {'Application Guide'}
                              </a>
                              <a style={{ color: 'rgb(53, 158, 255)', paddingLeft:'320px' }} href={common.contactAfsp} target="_blank">
                                {'Help'}
                              </a>
                              <a style={{ color: 'rgb(53, 158, 255)', paddingLeft:'320px' }} href={common.faq} target="_blank">
                                {'Frequently Asked Questions'}
                              </a>
                            </div>
                        )}
            </div>
        );
    }
}
